var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.333328C7.88422 0.333328 8.73206 0.684518 9.35718 1.30964C9.98231 1.93476 10.3335 2.78261 10.3335 3.66666C10.3335 4.55072 9.98231 5.39856 9.35718 6.02368C8.73206 6.64881 7.88422 6.99999 7.00016 6.99999C6.11611 6.99999 5.26826 6.64881 4.64314 6.02368C4.01802 5.39856 3.66683 4.55072 3.66683 3.66666C3.66683 2.78261 4.01802 1.93476 4.64314 1.30964C5.26826 0.684518 6.11611 0.333328 7.00016 0.333328ZM7.00016 1.99999C6.55813 1.99999 6.13421 2.17559 5.82165 2.48815C5.50909 2.80071 5.3335 3.22463 5.3335 3.66666C5.3335 4.10869 5.50909 4.53261 5.82165 4.84517C6.13421 5.15773 6.55813 5.33333 7.00016 5.33333C7.44219 5.33333 7.86611 5.15773 8.17867 4.84517C8.49123 4.53261 8.66683 4.10869 8.66683 3.66666C8.66683 3.22463 8.49123 2.80071 8.17867 2.48815C7.86611 2.17559 7.44219 1.99999 7.00016 1.99999ZM7.00016 7.83333C9.22516 7.83333 13.6668 8.94166 13.6668 11.1667V13.6667H0.333496V11.1667C0.333496 8.94166 4.77516 7.83333 7.00016 7.83333ZM7.00016 9.41666C4.52516 9.41666 1.91683 10.6333 1.91683 11.1667V12.0833H12.0835V11.1667C12.0835 10.6333 9.47516 9.41666 7.00016 9.41666Z",
    fill: "#0D2548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.da357470d8b7989fe5ba37ff0a96c67d.svg";
export { ForwardRef as ReactComponent };